<template>
  <a
    href="https://apps.apple.com/jp/app/%E5%A4%A7%E5%AD%A6%E7%94%9F%E3%81%AE%E3%81%9F%E3%82%81%E3%81%AE%E6%99%82%E9%96%93%E5%89%B2/id1095584799?mt=8"
    style="display:inline-block;overflow:hidden;background:url(https://linkmaker.itunes.apple.com/ja-jp/badge-lrg.svg?releaseDate=2016-03-28&kind=iossoftware&bubble=ios_apps) no-repeat;width:135px;height:40px;">
  </a>
</template>

<script>
export default {
  name: 'AppLink'
}
</script>

<style scoped>

</style>
